import React from 'react';
import classname from 'classnames';

import { BaseWidgetProps } from '../utils/type';

export interface VideoProps extends BaseWidgetProps {
  href?: string;
  poster?: string;
  controls?: boolean;
  autoplay?: boolean;
  preload?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Video = (props: VideoProps) => {
  const {
    prefixCls = 'crm-video',
    href,
    className,
    style,
    ...others
  } = props;

  const cls = classname(prefixCls, className);

  const attrs = {
    controls: true,
    preload: 'auto',
    ...others,
  };

  /* eslint-disable jsx-a11y/media-has-caption */
  return (
    <div className={cls} style={style}>
      <video src={href} {...attrs} />
    </div>
  );
  /* eslint-enable jsx-a11y/media-has-caption */
};

export default Video;
